import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router';
import { ComponentSync, LL_H_T, LL_V_C, LL_V_L, ModuleFE_AppConfig } from '@nu-art/thunderstorm-frontend/index';
import './Page_KnowledgeManager.scss';
import { _values } from '@nu-art/ts-common';
import { RouteDomainsMap } from '../../modules/app-module/ModuleFE_AppModule.js';
import { Component_Header, Component_SideNavBar } from '../components/index.js';
class KMDefault extends ComponentSync {
    render() {
        return _jsxs(LL_V_L, { id: 'km-default', children: [_jsx("div", { className: 'title', children: "Knowledge Manager" }), _jsx("div", { className: 'sub-title', children: "Please select a manager on the left" })] });
    }
}
export class KnowledgeManagerOverlay extends ComponentSync {
    static Route = {
        key: 'km',
        path: 'km',
        Component: this,
        index: true,
        modulesToAwait: [ModuleFE_AppConfig],
        children: [
            {
                key: 'km-default',
                path: '',
                Component: KMDefault,
                index: true,
            },
            ..._values(RouteDomainsMap).map(item => item.route),
        ],
    };
    render() {
        return _jsxs(LL_V_C, { className: 'knowledge-manager', children: [_jsx(Component_Header, {}), _jsxs(LL_H_T, { className: 'knowledge-manager__main', children: [_jsx(Component_SideNavBar, {}), _jsx("div", { className: 'knowledge-manager__main__content', children: _jsx(Outlet, {}) })] })] });
    }
}
